/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_Image_Default_WebInputs */

const vi_shop_group_image_default_web = /** @type {(inputs: Shop_Group_Image_Default_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mặc định (web)`)
};

/**

* @param {Shop_Group_Image_Default_WebInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_image_default_web = /** @type {((inputs?: Shop_Group_Image_Default_WebInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_Image_Default_WebInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_image_default_web(inputs)
});